<template>
  <div class="share-social">
    <div class="modal share-social-modal">
      <div class="modal-background" @click="closeModal"></div>
      <button class="modal-close is-large" @click="closeModal"></button>

      <div class="modal-card">
        <section class="modal-card-body">
          <p class="title is-4">Share TUK</p>

          <social-sharing
            url="https://tukapp.co"
            title="TUK, The Everything App"
            description="Magic Buttons To Get Stuff Done"
            quote="I don't know what humanity did before TUK..."
            hashtags="tuk, tukapp, tukthat, qrcode"
            twitter-user="tukapp"
            inline-template
          >
            <div class="buttons-wrapper">
              <network network="facebook" class="button">
                <i class="fab fa-facebook"></i>&nbsp;Facebook
              </network>
              <network network="line" class="button">
                <i class="fab fa-line"></i>&nbsp;Line
              </network>
              <network network="telegram" class="button">
                <i class="fab fa-telegram"></i>&nbsp;Telegram
              </network>
              <network network="twitter" class="button">
                <i class="fab fa-twitter"></i>&nbsp;Twitter
              </network>
              <network network="weibo" class="button">
                <i class="fab fa-weibo"></i>&nbsp;Weibo
              </network>
              <network network="whatsapp" class="button">
                <i class="fab fa-whatsapp"></i>&nbsp;Whatsapp
              </network>
            </div>
          </social-sharing>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShareSocial",
  data() {
    return {};
  },
  methods: {
    closeModal() {
      this.$el.querySelector(".modal").classList.remove("is-active");
    }
  }
};
</script>

<style scoped>
/* .button {
  padding: 2em !important;
} */
</style>
